import React from 'react';
import RoutineBuilder from '../components/routine/RoutineBuilder';
import RoutinePlayer from '../components/routine/RoutinePlayer';

function WorkoutView({ routineState, onStartRoutine, onExitRoutine, onMinimizeRoutine }) {

    // Si el player está "open" en el estado global, lo mostramos.
    // Pero ojo: si el usuario minimizó, routineState.isPlayerOpen será false, 
    // así que mostraremos el Builder de nuevo (o un estado de "Session in Progress").
    // Por ahora, si hay rutina activa pero minimizada, mostramos un aviso en el Builder o simplemente el Builder libre para crear otra (aunque sería raro).
    // Vamos a asumir que si isActive es true, mostramos pantalla de "Entrenamiento en Curso" con botón "Retomar".

    const isPlayerActive = routineState?.isPlayerOpen;
    const hasActiveSession = routineState?.isActive;

    if (isPlayerActive) {
        return (
            <div className="screen">
                <RoutinePlayer
                    routine={routineState.routine}
                    onExit={onExitRoutine}
                    onMinimize={onMinimizeRoutine}
                />
            </div>
        );
    }

    return (
        <div className="screen">
            <section className="section">
                <header className="section-header">
                    <h1 className="section-title">Entrenar</h1>
                    <p className="section-helper">Genera tu rutina o retoma tu sesión.</p>
                </header>

                {hasActiveSession ? (
                    <div className="card challenge-card">
                        <div className="chip chip-accent">Sesión Activa</div>
                        <h2>Entrenamiento en curso</h2>
                        <p style={{ marginBottom: '1rem', color: '#aaa' }}>Tienes una rutina iniciada y minimizada.</p>
                        <button
                            className="pill-button pill-button-primary full-width"
                            onClick={() => onMinimizeRoutine()} // Hack: This toggle implementation in App.js might need check. Actually onMinimize usually sets false. We need onMaximize.
                        // Let's assume for now we just need to set isPlayerOpen = true.
                        // We can reuse onStartRoutine passing the same routine, or simpler: create a handleResume in App.js.
                        // For now, I'll assume users won't minimize much inside the same tab, but let's be safe.
                        >
                            Retomar Entrenamiento
                        </button>
                        {/** Button to cancel? */}
                        <button
                            className="pill-button pill-button-ghost full-width"
                            style={{ marginTop: '0.5rem' }}
                            onClick={onExitRoutine}
                        >
                            Cancelar Sesión
                        </button>
                    </div>
                ) : (
                    <RoutineBuilder onRoutineGenerated={onStartRoutine} />
                )}
            </section>

            {/** Maybe add some history or stats here later */}
        </div>
    );
}

export default WorkoutView;
